<template>
  <div id="booking-confirmed" tabindex="-1">
    <div class="booking-confirmed">
      <div class="booking-confirmed__content">
        <h2 class="booking-confirmed__content__heading">{{ $t('The meeting has been booked') }}</h2>
        <p class="booking-confirmed__content__time"
          ><span aria-hidden="true" aria-labelledby="hiddenTime">{{ formattedDate }}, {{ selectedTime.value }}</span>
          <span id="timeSlot">{{ customFormatterScreenReader(formattedDate, selectedTime.value) }}</span>
          <span id="hiddenTime" class="d-none">{{
            customFormatterScreenReader(formattedDate, selectedTime.value)
          }}</span>
          <span v-if="meetingDuration"
            >({{
              $t('Xmin', {
                X: meetingDuration,
              })
            }})</span
          ></p
        >
        <p class="booking-confirmed__content__address">
          {{ appointmentData.service.unit }}
          <span v-if="appointmentData.wca" style="margin-left: 2px" :aria-label="$t('wheelchair_accessible')"
            >&#xf193;</span
          >
        </p>
        <p
          class="booking-confirmed__content__reservation-code__heading"
          v-if="appointmentData.code && appointmentData.branch_type == 'regular' && appointmentData.show_booking_code"
          >{{ $t('messages.your_code') }}</p
        >
        <p
          class="booking-confirmed__content__reservation-code__code"
          v-if="appointmentData.code && appointmentData.branch_type == 'regular' && appointmentData.show_booking_code"
          >{{ appointmentData.code }}</p
        >
        <div class="booking-confirmed__content__info__container">
          <p class="booking-confirmed__content__info">{{
            $t('We have sent you an e-mail with additional information about the meeting')
          }}</p>
          <p class="booking-confirmed__content__email">{{ appointmentData.customer.email }}</p>
        </div>
        <a class="booking-confirmed__content__button button button--secondary" :href="appointmentData.calendar_url">{{
          $t('Add to calendar')
        }}</a>
      </div>
      <div class="booking-confirmed__image" :aria-label="$t('picture_woman_laptop')"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useBookingStore, usePersonalStore } from '../store'
import moment from 'moment'
export default {
  name: 'ConfirmedView',
  data() {
    return {}
  },
  computed: {
    ...mapState(useBookingStore, [
      'groupValue',
      'selectedDate',
      'selectedTime',
      'selectedBranch',
      'appointmentData',
      'appointmentType',
      'meetingDuration',
    ]),
    ...mapState(usePersonalStore, [
      'fullName',
      'idCode',
      'email',
      'number',
      'companyName',
      'registrationNumber',
      'representativeName',
      'representativeIdCode',
    ]),
    formattedDate: {
      get() {
        return moment(this.appointmentData.date).format('DD.MM.YYYY')
      },
    },
  },
  mounted() {
    document.getElementById('booking-confirmed').focus()
  },
  methods: {
    goBack() {
      this.$router.push('/personal')
    },
    customFormatterScreenReader(date, time) {
      const dateTime = `${date} ${time}`
      const screenReaderDate = moment(dateTime, 'DD.MM.YYYY HH:mm').format('D MMMM, YYYY, h:mm A')
      return screenReaderDate
    },
  },
}
</script>

<style scoped>
#timeSlot {
  position: absolute;
  left: 0;
  opacity: 0;
  width: 130px;
  height: 20px;
}
</style>
